"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = Content;

var React = _interopRequireWildcard(require("react"));

var _react2 = require("linaria/react");

function _getRequireWildcardCache() { if (typeof WeakMap !== "function") return null; var cache = new WeakMap(); _getRequireWildcardCache = function () { return cache; }; return cache; }

function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } var cache = _getRequireWildcardCache(); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; if (obj != null) { var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } } newObj.default = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

const Container =
/*#__PURE__*/
(0, _react2.styled)("main")({
  name: "Container",
  class: "Container_c119hgic"
});
const Inner =
/*#__PURE__*/
(0, _react2.styled)("div")({
  name: "Inner",
  class: "Inner_ir6lat6"
});

function Content({
  children
}) {
  return React.createElement(Container, null, React.createElement(Inner, null, children));
}
//# sourceMappingURL=Content.js.map

require('../css/src/templates/Content.css');
